<template>
  <div
    class="relative"
  >
    <div
      ref="overlay"
      class="z-50 fixed left-0 top-0 bg-gray bg-opacity-60  w-full h-screen"
      :class="{'hidden': !loading}"
    >
      <!-- 'flex  justify-center items-center': loading,  -->
      <div class="loader ease-linear rounded-full mx-auto mt-[43vh] border-8 border-t-8 border-gray-200 h-24 w-24 " />
    </div>
 
     
    <slot />
  </div>
</template>
<style>
  .loader {
    border-top-color: rgb(151, 17, 16);
    -webkit-animation: spinner 1.5s linear infinite;
    animation: spinner 1.5s linear infinite;
  }
  
  @-webkit-keyframes spinner {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }
  
  @keyframes spinner {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  </style>
<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      topPosition: 50,
    }
  },
  mounted(){
    this.$nextTick(function () {
      window.addEventListener('scroll', this.calculateIconPosition)
    })
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.calculateIconPosition)
  },
  methods: {
    calculateIconPosition() {
      const iconRef = this.$refs.icon
      const overlayRef = this.$refs.overlay
      if (iconRef && overlayRef) {
        const overlayHeight = overlayRef.getBoundingClientRect().height
        const overlayAbsoluteTop = this.caluclateElAbsoluteOffsetTop(overlayRef)
        const scrollbarHeight = window.innerHeight * (window.innerHeight / document.body.offsetHeight)
        // console.log('rectangle bottom:' + ((articlesBottom + 75) - 150))
        // console.log('scroll y:' + (scrollbarHeight + window.scrollY))
        // console.log('scrollbarHeight y:' + (scrollbarHeight ))
        // console.log('window scroll y: ' + window.scrollY)
        // console.log('overlay absolutetop: ' + overlayAbsoluteTop)
        // console.log('overlay height: ' + overlayHeight)
        // console.log('overlay height: ' + overlayRef.offsetHeight)
        // positionTop = 
        
        this.topPosition = ((window.innerHeight / 2) * ((window.scrollY > overlayAbsoluteTop ? overlayAbsoluteTop : window.scrollY) / overlayAbsoluteTop))
        if(window.scrollY > (overlayAbsoluteTop + 50))
          this.topPosition += window.scrollY - (overlayAbsoluteTop + 50)

        if(this.topPosition < 50){
          this.topPosition = 50
        }
        if(this.topPosition > (overlayHeight - 125))
          this.topPosition  = overlayHeight - 125
        // if ((listBottom + 75) - 1000 < (scrollbarHeight + window.scrollY) && !this.$fetchState.pending) {
          
      }

    },
    caluclateElAbsoluteOffsetTop(el){
      const pageHeight = (document.body.scrollHeight - window.innerHeight)
      let itemOffsetTop = 0
      let parent = el
      while (parent && parent.tagName !== 'BODY') {
        itemOffsetTop = parent.offsetTop > itemOffsetTop ? parent.offsetTop : itemOffsetTop
        parent = parent.parentNode
      }
      if (itemOffsetTop > pageHeight) {
        itemOffsetTop = pageHeight
      } else if (itemOffsetTop < 0) {
        itemOffsetTop = 0
      }
      // const offset = itemOffsetTop - window.innerHeight
      return itemOffsetTop
    }
  }
}
</script>